// extracted by mini-css-extract-plugin
export default {"section":"Books_section__LsRqZ","type":"Books_type__zD1uq"};